var _path, _path2, _ellipse, _g, _path3, _path4, _path5, _path6, _ellipse2, _path7, _path8, _path9, _ellipse3, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 318,
    viewBox: "0 0 338 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_634_2843)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_634_2843)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.46 216.8H105.98V250.9H127.54V283.02H105.98V314.48H69.46V283.02H1.48V257.28L54.72 153.22H93.66L43.28 250.9H69.46V216.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.46 216.8V215.8H68.46V216.8H69.46ZM105.98 216.8H106.98V215.8H105.98V216.8ZM105.98 250.9H104.98V251.9H105.98V250.9ZM127.54 250.9H128.54V249.9H127.54V250.9ZM127.54 283.02V284.02H128.54V283.02H127.54ZM105.98 283.02V282.02H104.98V283.02H105.98ZM105.98 314.48V315.48H106.98V314.48H105.98ZM69.46 314.48H68.46V315.48H69.46V314.48ZM69.46 283.02H70.46V282.02H69.46V283.02ZM1.48 283.02H0.48V284.02H1.48V283.02ZM1.48 257.28L0.589752 256.825L0.48 257.039V257.28H1.48ZM54.72 153.22V152.22H54.1083L53.8298 152.765L54.72 153.22ZM93.66 153.22L94.5488 153.678L95.3009 152.22H93.66V153.22ZM43.28 250.9L42.3913 250.442L41.6391 251.9H43.28V250.9ZM69.46 250.9V251.9H70.46V250.9H69.46ZM69.46 217.8H105.98V215.8H69.46V217.8ZM104.98 216.8V250.9H106.98V216.8H104.98ZM105.98 251.9H127.54V249.9H105.98V251.9ZM126.54 250.9V283.02H128.54V250.9H126.54ZM127.54 282.02H105.98V284.02H127.54V282.02ZM104.98 283.02V314.48H106.98V283.02H104.98ZM105.98 313.48H69.46V315.48H105.98V313.48ZM70.46 314.48V283.02H68.46V314.48H70.46ZM69.46 282.02H1.48V284.02H69.46V282.02ZM2.48 283.02V257.28H0.48V283.02H2.48ZM2.37025 257.735L55.6103 153.675L53.8298 152.765L0.589752 256.825L2.37025 257.735ZM54.72 154.22H93.66V152.22H54.72V154.22ZM92.7712 152.762L42.3913 250.442L44.1688 251.358L94.5488 153.678L92.7712 152.762ZM43.28 251.9H69.46V249.9H43.28V251.9ZM70.46 250.9V216.8H68.46V250.9H70.46Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_634_2843",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 148,
    width: 168,
    height: 168
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 172,
    cy: 232,
    rx: 83.9998,
    ry: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_634_2843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255 232C255 277.84 217.839 315 172 315C126.16 315 89 277.84 89 232C89 186.16 126.16 149 172 149C217.839 149 255 186.16 255 232Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.934 208.013C149.537 208.013 156.511 201.039 156.511 192.437C156.511 188.924 155.348 185.682 153.386 183.076C151.292 182.03 148.93 181.441 146.43 181.441C137.827 181.441 130.854 188.415 130.854 197.018C130.854 200.531 132.016 203.772 133.978 206.378C136.072 207.425 138.434 208.013 140.934 208.013Z",
    fill: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.932,
    cy: 192.437,
    rx: 15.5768,
    ry: 15.5768,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.251 279.483C176.83 279.483 182.163 274.15 182.163 267.572C182.163 265.503 181.636 263.557 180.708 261.862C179.446 261.406 178.085 261.158 176.666 261.158C170.087 261.158 164.754 266.491 164.754 273.07C164.754 275.139 165.281 277.085 166.209 278.78C167.471 279.235 168.832 279.483 170.251 279.483Z",
    fill: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.251,
    cy: 267.572,
    rx: 11.9116,
    ry: 11.9117,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.983,
    cy: 246.955,
    rx: 6.8721,
    ry: 6.87212,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 227.977,
    cy: 214.427,
    rx: 8.24652,
    ry: 8.24654,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.15,
    cy: 164.948,
    rx: 11.9116,
    ry: 11.9117,
    stroke: "black",
    strokeWidth: 2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278.46 216.8H314.98V250.9H336.54V283.02H314.98V314.48H278.46V283.02H210.48V257.28L263.72 153.22H302.66L252.28 250.9H278.46V216.8Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M278.46 216.8V215.8H277.46V216.8H278.46ZM314.98 216.8H315.98V215.8H314.98V216.8ZM314.98 250.9H313.98V251.9H314.98V250.9ZM336.54 250.9H337.54V249.9H336.54V250.9ZM336.54 283.02V284.02H337.54V283.02H336.54ZM314.98 283.02V282.02H313.98V283.02H314.98ZM314.98 314.48V315.48H315.98V314.48H314.98ZM278.46 314.48H277.46V315.48H278.46V314.48ZM278.46 283.02H279.46V282.02H278.46V283.02ZM210.48 283.02H209.48V284.02H210.48V283.02ZM210.48 257.28L209.59 256.825L209.48 257.039V257.28H210.48ZM263.72 153.22V152.22H263.108L262.83 152.765L263.72 153.22ZM302.66 153.22L303.549 153.678L304.301 152.22H302.66V153.22ZM252.28 250.9L251.391 250.442L250.639 251.9H252.28V250.9ZM278.46 250.9V251.9H279.46V250.9H278.46ZM278.46 217.8H314.98V215.8H278.46V217.8ZM313.98 216.8V250.9H315.98V216.8H313.98ZM314.98 251.9H336.54V249.9H314.98V251.9ZM335.54 250.9V283.02H337.54V250.9H335.54ZM336.54 282.02H314.98V284.02H336.54V282.02ZM313.98 283.02V314.48H315.98V283.02H313.98ZM314.98 313.48H278.46V315.48H314.98V313.48ZM279.46 314.48V283.02H277.46V314.48H279.46ZM278.46 282.02H210.48V284.02H278.46V282.02ZM211.48 283.02V257.28H209.48V283.02H211.48ZM211.37 257.735L264.61 153.675L262.83 152.765L209.59 256.825L211.37 257.735ZM263.72 154.22H302.66V152.22H263.72V154.22ZM301.771 152.762L251.391 250.442L253.169 251.358L303.549 153.678L301.771 152.762ZM252.28 251.9H278.46V249.9H252.28V251.9ZM279.46 250.9V216.8H277.46V250.9H279.46Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256.098 15.7789L257.521 10.4663",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.118 148.546L239.946 45.7501L265.992 63L231 316.5L164.118 148.546Z",
    fill: "url(#paint0_linear_634_2843)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.897,
    cy: 25.7917,
    rx: 19,
    ry: 10.5,
    transform: "rotate(15 252.897 25.7917)",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M304.581 60.8634C301.294 73.1332 272.681 76.1271 240.673 67.5506C208.665 58.9741 185.383 42.0749 188.67 29.8052C191.958 17.5354 220.571 14.5415 252.579 23.118C284.587 31.6945 307.869 48.5937 304.581 60.8634Z",
    fill: "#304FF2",
    stroke: "white",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M295.112 61.4317C297.685 51.8293 277.715 38.1353 250.508 30.8453C223.302 23.5552 199.16 25.4298 196.587 35.0322",
    stroke: "white",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M246.108 47.2664C233.305 43.8358 221.825 45.1631 220.467 50.231L149 136.753L156 218L266.832 62.6544C268.19 57.5864 258.911 50.697 246.108 47.2664Z",
    fill: "url(#paint1_linear_634_2843)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.649,
    cy: 56.4426,
    rx: 24,
    ry: 9.5,
    transform: "rotate(15 243.649 56.4426)",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M261.197 8.34473C260.768 9.94513 259.123 10.8949 257.523 10.4661C255.922 10.0372 254.972 8.39222 255.401 6.79182C255.83 5.19142 257.475 4.24167 259.076 4.6705C260.676 5.09933 261.626 6.74434 261.197 8.34473Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172 130L181 118M208 82L190 106L185.5 112",
    stroke: "black",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M207.499 107.5L229.499 76.0001",
    stroke: "black",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.21 62.082C101.216 84.4092 72.229 84.4067 71.2816 68.6237C70.7116 59.1261 84.0467 59.6208 87.0299 69.7376C90.0132 79.8545 71.538 96.6448 45.0004 95.2281",
    stroke: "black",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_634_2843",
    x1: 261.646,
    y1: 40.1074,
    x2: 226.619,
    y2: 160.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_634_2843",
    x1: 241.761,
    y1: 46.1028,
    x2: 201.5,
    y2: 165.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_634_2843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 338,
    height: 318,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_634_2843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 338,
    height: 168,
    fill: "white",
    transform: "translate(0 148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.c7f417a86f2e604c10da13f5aa9776b6.svg";
export { ForwardRef as ReactComponent };